var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "promo-bar" }, [
    _c("div", { staticClass: "container container--promo" }, [
      _c("div", {
        staticClass: "promo-bar__text u-text-center",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _c(
        "div",
        { staticClass: "promo-bar__menu" },
        _vm._l(_vm.links, function (link) {
          return _c(
            "a",
            {
              key: link.title,
              staticClass: "promo-bar__menu-link",
              attrs: { href: _vm.baseURL + link.url },
            },
            [_vm._v(_vm._s(link.title))]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }